import React, { useState, useRef, useEffect } from 'react';
import SubmitAnswerButton from './submitanswersbutton';
import { useBrowserSpeechRecognition } from '../../hooks/usebrowserspeechrecognition';

const ReadAloudTest = ({ questionNumber, onNext, isLastQuestion, questionData,getTotalExamVideoDuration, candidateTestId, timeRemaining, getVideoDuration,isLastQuestionOfSection,currentSection,sectionQuestions }) => {
  
  const [isRecording, setIsRecording] = useState(false);
  const [audioBlob, setAudioBlob] = useState(null);
  
  const [hasRecorded, setHasRecorded] = useState(false);
  const [recordingTime, setRecordingTime] = useState(0);
  const [timerId, setTimerId] = useState(null);
  const mediaRecorderRef = useRef(null);
  const audioChunksRef = useRef([]);

  const {
    transcript,
    interimTranscript,
    resetTranscript,
    startListening,
    stopListening,
    browserSupportsSpeechRecognition
  } = useBrowserSpeechRecognition();


  const sampleText = questionData?.text || "Please read the following text aloud clearly.";

  

  useEffect(() => {
    if (!browserSupportsSpeechRecognition) {
      console.warn('Browser does not support speech recognition');
    }

    return () => {
      if (timerId) {
        clearInterval(timerId);
        setTimerId(null);
      }
      if (mediaRecorderRef.current && mediaRecorderRef.current.state !== 'inactive') {
        mediaRecorderRef.current.stop();
      }

      stopListening();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const startRecording = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      mediaRecorderRef.current = new MediaRecorder(stream);
      audioChunksRef.current = [];

      mediaRecorderRef.current.ondataavailable = (event) => {
        audioChunksRef.current.push(event.data);
      };

      mediaRecorderRef.current.onstop = () => {
        const audioBlob = new Blob(audioChunksRef.current, { type: 'audio/wav' });
        setAudioBlob(audioBlob);
        setHasRecorded(true);
        
        stream.getTracks().forEach(track => track.stop());
      };

      mediaRecorderRef.current.start();
      setIsRecording(true);
      setRecordingTime(0);
      resetTranscript();


      startListening({ 
        continuous: true,
        language: 'en-US'
      });


      const id = setInterval(() => {
        setRecordingTime(prev => prev + 1);
      }, 1000);
      setTimerId(id);

    } catch (error) {
      console.error('Error accessing microphone:', error);
    }
  };

  const stopRecording = () => {
    if (mediaRecorderRef.current && isRecording) {
      mediaRecorderRef.current.stop();
      setIsRecording(false);
      

      stopListening();
      
      if (timerId) {
        clearInterval(timerId);
        setTimerId(null);
      }
    }
  };

  return (
    <div className="test-type-container">
      <div className="step-question">
        <h3 className="question-title">Read the following text aloud:</h3>
        <p className="reading-text">{sampleText}</p>
      </div>

      
      {(isRecording || hasRecorded) && (
        <div className="transcription-box">
          <h4 className="transcription-title">
            {isRecording ? 'Live Transcription:' : 'Your Response:'}
          </h4>
          <div className="transcription-content">
            {transcript || interimTranscript ? (
              <p className="transcription-text">
                {transcript}
                {interimTranscript && <span className="interim-text">{interimTranscript}</span>}
              </p>
            ) : (
              <p className="transcription-placeholder">Start speaking to see transcription...</p>
            )}
          </div>
        </div>
      )}

      <div className="recording-controls">
        {!isRecording && !hasRecorded && (
          <button className="btn-record" onClick={startRecording}>
            Start Recording
          </button>
        )}

        {isRecording && (
          <div className="recording-active">
            <button className="btn-stop-recording" onClick={stopRecording}>
              Stop Recording
            </button>
            <div className="recording-indicator">
              <span className="recording-dot"></span>
              Recording... {recordingTime}s
            </div>
          </div>
        )}

        {hasRecorded && (
            <div className="recording-complete">
              <div className="success-message">
                Recording completed ({recordingTime}s)
              </div>
            </div>
          )}
      </div>

      
        <SubmitAnswerButton
          questionNumber={questionNumber}
          questionData={questionData}
          candidateTestId={candidateTestId}
          isLastQuestion={isLastQuestion}
          isLastQuestionOfSection={isLastQuestionOfSection} 
          onNext={onNext}
          audioBlob={audioBlob}
          transcript={transcript}
          recordingTime={recordingTime}
          testType="audio"
          hasRecorded={hasRecorded}
          timeRemaining={timeRemaining}
          isRecording={isRecording}
          onStopRecording={stopRecording}
          getVideoDuration={getVideoDuration}
          section={currentSection}
          sectionQuestions={sectionQuestions}
          getTotalExamVideoDuration={getTotalExamVideoDuration}
        />
     
    </div>
  );
};

export default ReadAloudTest;
